import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideTertiaireStub } from '../../../../config/aides-tertiaire';

export default function TertiaireCoupDePouceCvcPage() {
  const aide = getAideTertiaireStub('coup-de-pouce-cvc');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="tertiaire" />;
}
